/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ address: NonNullable<unknown> }} Email_Goes_ToInputs */

const th_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`อีเมลจะส่งไปที่ ${i?.address}`)
};

const en_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Email goes to ${i?.address}.`)
};

const ja_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`メールは ${i?.address} に届きます。`)
};

const zh_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`邮件将发送至 ${i?.address}。`)
};

const es_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El correo se envía a ${i?.address}.`)
};

const pt_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O e-mail vai para ${i?.address}.`)
};

const id_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Email dikirim ke ${i?.address}.`)
};

const fr_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Les e-mails vont à ${i?.address}.`)
};

const tl_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Papunta sa ${i?.address} ang mga email.`)
};

const vi_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Email được gửi tới ${i?.address}.`)
};

const ko_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`이메일은 ${i?.address}(으)로 갑니다.`)
};

const de_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`E-Mails gehen an ${i?.address}.`)
};

const ru_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Письма уходят на ${i?.address}.`)
};

const tr_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`E-postalar ${i?.address} adresine gider.`)
};

const it_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le email vanno a ${i?.address}.`)
};

const pl_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`E-maile trafiają na ${i?.address}.`)
};

const uk_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Листи надходять на ${i?.address}.`)
};

const hi_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ईमेल ${i?.address} पर जाते हैं।`)
};

const ar_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تصل الرسائل إلى ${i?.address}.`)
};

const ms_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`E-mel dihantar ke ${i?.address}.`)
};

const bn_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ইমেল ${i?.address}-এ যায়।`)
};

const zh_tw2_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`郵件會寄到 ${i?.address}。`)
};

const zh_hk2_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`郵件會寄到 ${i?.address}。`)
};

const ur_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ای میل ${i?.address} پر جاتی ہیں۔`)
};

const fa_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ایمیل‌ها به ${i?.address} می‌روند.`)
};

const sw_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Barua pepe huenda ${i?.address}.`)
};

const nl_email_goes_to = /** @type {(inputs: Email_Goes_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`E-mails gaan naar ${i?.address}.`)
};

/**
* | output |
* | --- |
* | "Email goes to {address}." |
*
* @param {Email_Goes_ToInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_goes_to = /** @type {((inputs: Email_Goes_ToInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Goes_ToInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_goes_to(inputs)
	if (locale === "ja") return ja_email_goes_to(inputs)
	if (locale === "zh") return zh_email_goes_to(inputs)
	if (locale === "es") return es_email_goes_to(inputs)
	if (locale === "pt") return pt_email_goes_to(inputs)
	if (locale === "id") return id_email_goes_to(inputs)
	if (locale === "fr") return fr_email_goes_to(inputs)
	if (locale === "tl") return tl_email_goes_to(inputs)
	if (locale === "vi") return vi_email_goes_to(inputs)
	if (locale === "ko") return ko_email_goes_to(inputs)
	if (locale === "de") return de_email_goes_to(inputs)
	if (locale === "ru") return ru_email_goes_to(inputs)
	if (locale === "tr") return tr_email_goes_to(inputs)
	if (locale === "it") return it_email_goes_to(inputs)
	if (locale === "pl") return pl_email_goes_to(inputs)
	if (locale === "uk") return uk_email_goes_to(inputs)
	if (locale === "hi") return hi_email_goes_to(inputs)
	if (locale === "ar") return ar_email_goes_to(inputs)
	if (locale === "ms") return ms_email_goes_to(inputs)
	if (locale === "bn") return bn_email_goes_to(inputs)
	if (locale === "zh-TW") return zh_tw2_email_goes_to(inputs)
	if (locale === "zh-HK") return zh_hk2_email_goes_to(inputs)
	if (locale === "ur") return ur_email_goes_to(inputs)
	if (locale === "fa") return fa_email_goes_to(inputs)
	if (locale === "sw") return sw_email_goes_to(inputs)
	if (locale === "nl") return nl_email_goes_to(inputs)
	return en_email_goes_to(inputs)
});